import React, { useEffect, useMemo, useState } from "react";
import { Box, Paper, Typography, Divider } from "@material-ui/core";
import BranchSelect from "../../Components/BranchSelect";
import DateRangeBar from "../../Components/DateRangeBar";
import ExportButtons from "../../Components/ExportButtons";
import DataTable from "../../Components/DataTable";
import { Api } from "../../api/client";
import { money, num, pct } from "../../utils/format";
import { todayISO, daysAgoISO } from "./_date";

export default function PromosDescuentos(){
  const [branches, setBranches] = useState([]);
  const [branchId, setBranchId] = useState("");
  const [range, setRange] = useState({ from: daysAgoISO(7), to: todayISO() });

  // TODO: cuando exista Api.promos(params) se reemplaza
  const [rows, setRows] = useState([]);

  const params = useMemo(()=>({
    from: range.from,
    to: range.to,
    branch: branchId
  }), [range, branchId]);

  useEffect(()=>{
    Api.branches()
      .then(res => setBranches(res.data))
      .catch(()=> setBranches([{id:"", nombre:"Todas"}]));
  }, []);

  useEffect(()=>{
    // ✅ sin inventar endpoint: solo dejamos listo
    setRows([]);
  }, [params]);

  const columns = [
    { key:"fecha", label:"Fecha" },
    { key:"promo", label:"Promo/Cupón" },
    { key:"pedidos", label:"Pedidos", render:r=>num(r.pedidos) },
    { key:"descuento", label:"Descuento USD", render:r=>money(r.descuento) },
    { key:"impacto", label:"Impacto %", render:r=>pct(r.impacto) },
  ];

  return (
    <Paper style={{padding:18, borderRadius:14}}>
      <Typography variant="h6" style={{fontWeight:900}}>Promociones y descuentos</Typography>
      <Typography variant="body2" style={{opacity:.75, marginTop:6}}>
        (Pendiente de API) Aquí irá el impacto de cupones/combos en ventas y rentabilidad.
      </Typography>
      <Divider style={{margin:"12px 0"}}/>

      <Box display="flex" gridGap={12} flexWrap="wrap">
        <BranchSelect value={branchId} options={branches} onChange={setBranchId}/>
        <DateRangeBar from={range.from} to={range.to} onChange={setRange}/>
        <ExportButtons filename={`promos_${params.from}_a_${params.to}.csv`} rows={rows}/>
      </Box>

      <Box mt={2}>
        <DataTable columns={columns} rows={rows}/>
      </Box>
    </Paper>
  );
}